
import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop, PropSync } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { vuex } from "@/store";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import moment from "moment";

// interfaces

// components

const globals = namespace("globals");

@Component({
  components: {
  }
})
export default class L3DatePicker extends Vue {
  @PropSync("dateTime")
  syncedDateTime!: Date | null;
  @Prop()
  label!: string;
  @Prop({ default: false})
  isNullableDate!: boolean;
  @PropSync("isValid")
  syncedIsValid!: boolean;

  showDateDlg = false;
  dateAsIso: string | null = "";
  dateAsText: string | null = "";

  $refs!: {};

  mounted() {
    this.init();
  }

  // updated() {
  //   console.log("l3 date picker updated");
  //   this.update();
  // }

  // @Watch("syncedShowDialog")
  // async onShowDialogChanged(open: boolean) {
  //   if (open) {
  //     // On dialog open

  //     // Disable body scroll on iOS
  //     this.$nextTick(async () => {
  //       await this.$globalHelper.delay(10);
  //       const modal = document.querySelector('.modal');
  //       disableBodyScroll(modal);
  //     });
  //   } else {
  //     // Dialog closing
  //     clearAllBodyScrollLocks();
  //   }
  // }

  // beforeDestroy() {
  //   clearAllBodyScrollLocks();
  // }

  // closeDialog() {
  //   this.syncedShowDialog = false;
  // }


  @Watch("syncedDateTime")
  onDateChanged() {
    // console.log("onDateChanged");
    this.init();
  }

  init() {
    let isoDate = moment(this.syncedDateTime).format("yyyy-MM-DD");
    if (this.dateAsIso == isoDate)
      return;

    this.dateAsIso = isoDate;
    this.dateAsText = moment(this.dateAsIso).format("DD.MM.yyyy");
    // console.log("Update to: " + this.dateAsText);
    this.syncedIsValid = this.isValidDate(this.dateAsText);
  }

  onDatePicker() {
    if (!this.dateAsIso) {
      this.dateAsText = null;
      this.syncedIsValid = this.isNullableDate;
      this.showDateDlg = false;
      return;
    }

    this.dateAsText = moment(this.dateAsIso).format("DD.MM.yyyy");
    this.syncedIsValid = this.isValidDate(this.dateAsText);
    this.setDate();
    this.showDateDlg = false;
  }

  get dateFormated() {
    return this.formatDate(this.dateAsIso);
  }

  setDate() {
    // console.log("Setting date with dateAsIso:", this.dateAsIso);
    let time = moment(this.syncedDateTime).format("HH:mm"); // HH => 24h format
    this.syncedDateTime = moment(`${this.dateAsIso}T${time}`).toDate();
    this.$emit("dateChanged:DatePicker");
  }

  onDateTextChanged(): void {
    // console.log("onDateTextChanged with dateAsText:", this.dateAsText);
    if (!this.dateAsText) {
      this.syncedIsValid = this.isNullableDate;
      if (this.isNullableDate) {
        this.dateAsIso = null;
        this.syncedDateTime = null;
        this.$emit("dateChanged:DatePicker");
      }

      return;
    }

    if (this.isPartialDate(this.dateAsText)) {
      // console.log("Partial date detected:", this.dateAsText);
      this.syncedIsValid = false;
      return;
    }

    const localIsValid = this.isValidDate(this.dateAsText);
    this.syncedIsValid = localIsValid;

    if (!localIsValid) {
      // console.log("Invalid date format");
      return;
    }

    const isoDate = this.convertDeDateToIso(this.dateAsText);
    // console.log("isoDate", isoDate);

    this.dateAsIso = isoDate;
    this.setDate();
  }

  isPartialDate(val: string | null): boolean {
    if (!val) {
      return false;
    }

    const trimmed = val.trim();
    const parts = trimmed.split('.');

    // Not all 3 parts are present -> partial input
    if (parts.length !== 3) {
      return true;
    }

    if (parts.some((part) => part === "")) {
      return true;
    }

    // Only digits are allowed; invalid characters mean this is not a partial date
    if (!parts.every((part) => /^\d+$/.test(part))) {
      return false;
    }

    // Day and month may have at most 2 digits
    if (parts[0].length > 2 || parts[1].length > 2) {
      return false;
    }

    // Year must have 4 digits to be complete
    if (parts[2].length < 4) {
      return true;
    }

    return false;
  }

  isValidDate(val: string | null): boolean {
    if (!val) {
      return this.isNullableDate;
    }

    const trimmed = val.trim();

    // Debugging removed

    // Partial dates are not valid
    if (this.isPartialDate(trimmed)) {
      return false;
    }

    const parts = trimmed.split('.');

    // Format must be exactly day.month.year
    if (parts.length !== 3) {
      return false;
    }

    const [day, month, year] = parts;

    // All parts must be digits with appropriate lengths
    if (!/^\d{1,2}$/.test(day) || !/^\d{1,2}$/.test(month) || !/^\d{4}$/.test(year)) {
      return false;
    }

    const dayNum = parseInt(day, 10);
    const monthNum = parseInt(month, 10);
    const yearNum = parseInt(year, 10);

    // parts debug removed

    if (dayNum < 1 || dayNum > 31) return false;
    if (monthNum < 1 || monthNum > 12) return false;

    // Use native Date to validate day/month/year (avoids moment parsing quirks)
    const d = new Date(yearNum, monthNum - 1, dayNum);
    if (d.getFullYear() !== yearNum) return false;
    if (d.getMonth() !== monthNum - 1) return false;
    if (d.getDate() !== dayNum) return false;

    return true;
  }

  convertDeDateToIso(val: string): string {
    // console.log("val", val);
    // console.log("this.dateAsText", this.dateAsText);
    // let dateSplit = this.dateAsText?.split('.');
    let dateSplit = val.split('.');
    let isoDate = dateSplit![2] + "-";
    if (dateSplit![1].length < 2)
      isoDate += "0";
    isoDate += dateSplit![1] + "-";
    if (dateSplit![0].length < 2)
      isoDate += "0";
    isoDate += dateSplit![0];
    return isoDate;
  }

  formatDate(date) {
    if (date == null)
      return "-";

    return moment(date).format("DD.MM.yyyy");
  }

  nullableDateRules = [
    (v: string) => this.isValidDate(v) || "falsches Datumsformat"
  ];

  dateRules = [
    (v: string) => !!v || "Datum erforderlich",
    // (v: string) => (v && this.isValidDate(v)) || "falsches Datumsformat"
    (v: string) => this.isValidDate(v) || "falsches Datumsformat"
  ];

}
